import SalaryCard from "./SalaryCard";

export default SalaryCard;
